<script setup>
/**
 * Popup proxy that renders as a menu on desktop and a bottom dialog on mobile.
 *
 * @status recommended
 * @group overlays
 * @useWhen Wrapping popup content (e.g. a date picker) that must adapt to the platform
 * @see https://quasar.dev/vue-components/popup-proxy Quasar q-popup-proxy API
 */
defineOptions({ name: 'HrPopupProxy' });
</script>

<template>
  <q-popup-proxy v-bind="$attrs">
    <!-- @slot Popup content. -->
    <slot />
  </q-popup-proxy>
</template>
